/**
 * Age Blocked Screen — Phase 2E
 *
 * Shown when a user enters a birth year indicating they are under 13.
 * COPPA requirement: cannot collect data from users under 13.
 *
 * No navigation forward. User can contact support or return to home.
 */

import { View, Text, Pressable, StyleSheet, Linking, SafeAreaView } from 'react-native';
import { useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';
import { TYPO } from '@/constants/typography';

const SUPPORT_EMAIL = 'support@douevenlift.com';

export default function AgeBlockedScreen() {
  const { theme } = useTheme();
  const c = theme.colors;
  const router = useRouter();

  const handleContactSupport = () => {
    Linking.openURL(`mailto:${SUPPORT_EMAIL}?subject=DUEL%20Age%20Restriction%20Question`).catch(() => {});
  };

  const handleGoHome = () => {
    // Navigate away from onboarding entirely
    router.replace('/');
  };

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: c.background }]}>
      <View style={styles.inner}>
        <Text style={styles.icon}>🔒</Text>

        <Text style={[styles.title, { color: c.text, fontFamily: TYPO.heading.bold }]}>
          Age Requirement
        </Text>

        <Text style={[styles.body, { color: c.textSecondary }]}>
          DUEL requires users to be at least 13 years old.
        </Text>

        <Text style={[styles.body, { color: c.textSecondary }]}>
          If you believe this is an error, please contact our support team.
        </Text>

        <Pressable
          style={[styles.btn, { borderColor: c.border }]}
          onPress={handleContactSupport}
          accessibilityRole="button"
          accessibilityLabel="Contact Support"
        >
          <Text style={[styles.btnText, { color: c.text, fontFamily: TYPO.body.semibold }]}>
            Contact Support
          </Text>
        </Pressable>

        <Pressable
          onPress={handleGoHome}
          accessibilityRole="button"
          accessibilityLabel="Go back to home"
        >
          <Text style={[styles.homeLink, { color: c.textTertiary }]}>Back to Home</Text>
        </Pressable>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  inner: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
    gap: 20,
  },
  icon: {
    fontSize: 56,
    marginBottom: 8,
  },
  title: {
    fontSize: 26,
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 1,
    marginBottom: 4,
  },
  body: {
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 24,
    maxWidth: 320,
  },
  btn: {
    borderWidth: 1.5,
    borderRadius: 4,
    paddingVertical: 14,
    paddingHorizontal: 32,
    marginTop: 12,
  },
  btnText: {
    fontSize: 15,
  },
  homeLink: {
    fontSize: 14,
    textDecorationLine: 'underline',
    marginTop: 4,
  },
});
